import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import '../../interfaces/slider.interface';
import './supporting-content.component.scss';
var SupportingContent = /** @class */ (function (_super) {
    tslib_1.__extends(SupportingContent, _super);
    function SupportingContent(element) {
        return _super.call(this, element) || this;
    }
    SupportingContent.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 3,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.4,
                    spaceBetween: 30,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    SupportingContent.prototype.bindEvents = function () { };
    return SupportingContent;
}(Base));
export { SupportingContent };



//////////////////
// WEBPACK FOOTER
// ./components/supporting-content/supporting-content.component.ts
// module id = 515
// module chunks = 0